module.exports = __webpack_public_path__ + "static/media/allie14.4b0f3b15.jpg";